export default __webpack_public_path__ + "static/wizard-fade-purple-512-761ab6451d42615af23ded3d58f74c28.gif";